import { StoreModelType } from '@smx-ui-model/types';
import React, { createContext, useCallback, useState } from 'react';

export interface IContext {
    currentId?: string;
    connectionId?: string;
    isLoading?: boolean;
    setIsLoading?: (value: boolean) => void;
    isOpen?: boolean;
    setIsOpen?: (value: boolean) => void;
    errorInfo?: any;
    setErrorInfo?: (value?: any) => void;
    parentNode?: any;
    parentData?: { [key: string]: any };
    parentModelName?: keyof StoreModelType;
    filterProject?: string[];
}

export const SmxInspectorContext = createContext<IContext>({});

interface IPermissionProvider extends IContext {
    children: React.ReactNode;
}

const InspectorProvider: React.FC<IPermissionProvider> = ({
    connectionId,
    currentId,
    isLoading: initialLoading,
    isOpen: initialOpen,
    parentNode,
    parentData,
    parentModelName,
    filterProject,
    children,
}) => {
    const [isLoading, setIsLoadingState] = useState<boolean>(!!initialLoading);
    const [isOpen, setIsOpenState] = useState<boolean>(!!initialOpen);
    const [errorInfo, setErrorInfoState] = useState();

    const setIsLoading = useCallback((value: boolean) => {
        setIsLoadingState(value);
    }, []);

    const setIsOpen = useCallback((value: boolean) => {
        setIsOpenState(value);
    }, []);

    const setErrorInfo = useCallback((value?: any) => {
        setErrorInfoState(value);
    }, []);

    return (
        <SmxInspectorContext.Provider
            value={{
                connectionId,
                isLoading,
                setIsLoading,
                errorInfo,
                setErrorInfo,
                isOpen,
                setIsOpen,
                currentId,
                parentNode,
                parentData,
                parentModelName,
                filterProject,
            }}
        >
            {children}
        </SmxInspectorContext.Provider>
    );
};

export default InspectorProvider;
